// createToggleInlineStyleButton.js
import React from 'react';
import { RichUtils } from 'draft-js';
import cx from 'classnames';

/**
 * Factory per creare un bottone inline di font-size
 * @param {number} size - Font size in pixel (es. 12, 14, 18, 24)
 * @returns {React.Component} - Bottone React da usare nella InlineToolbar
 */
const createToggleInlineStyleButton = ({
  prefix,
  styleName,
  style,
  title,
  children,
}) => {
  const FontSizeButton = ({ getEditorState, setEditorState, theme }) => {
    const editorState = getEditorState();
    const currentStyle = editorState.getCurrentInlineStyle();
    const isActive = currentStyle.has(styleName);

    const toggleFontSize = () => {
      const editorState = getEditorState();
      const currentStyle = editorState.getCurrentInlineStyle();
      let newEditorState = editorState;

      // Rimuovi altri stili ${prefix}_XX
      currentStyle.forEach((s) => {
        if (s.startsWith(prefix)) {
          newEditorState = RichUtils.toggleInlineStyle(newEditorState, s);
        }
      });

      // Applica lo stile se non già attivo
      if (!currentStyle.has(styleName)) {
        newEditorState = RichUtils.toggleInlineStyle(newEditorState, styleName);
      }

      setEditorState(newEditorState);
    };

    const className = cx(theme.button, { [theme.active]: isActive });

    return (
      <button
        type="button"
        onMouseDown={(e) => {
          e.preventDefault();
          toggleFontSize();
        }}
        title={title}
        className={className}
      >
        {children}
      </button>
    );
  };

  return FontSizeButton;
};

export default createToggleInlineStyleButton;
